<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <label>Pessoa Física</label>
      <multiselect
        v-model="pessoaFisicaSelected"
        :options="this.$parent.optionsPessoaFisica"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        class="text-danger"
        v-text="form.errors.get('pessoa_id')"
        v-if="form.errors.has('pessoa_id')"
      ></b-form-feedback>

      <label tag="div">CNH</label>
      <b-form-input type="text" placeholder="CNH" v-model="form.cnh" name="cnh">
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('cnh')"
        v-if="form.errors.has('cnh')"
      ></b-form-feedback>

      <label tag="div">Data vencimento CNH</label>
      <b-form-datepicker
        locale="pt-br"
        reset-button
        placeholder="Venciamento CNH"
        v-model="form.dt_vencimento_cnh"
        class="form-control"
        :date-format-options="{
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
        }"
      >
      </b-form-datepicker>
      <b-form-feedback
        v-text="form.errors.get('dt_vencimento_cnh')"
        v-if="form.errors.has('dt_vencimento_cnh')"
      ></b-form-feedback>

      <b-form-feedback
        v-text="form.errors.get('descr')"
        v-if="form.errors.has('descr')"
      ></b-form-feedback>

      <label>Categoria</label>
      <multiselect
        v-model="categoriaSelected"
        :options="this.$parent.optionsCategoria"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        class="text-danger"
        v-text="form.errors.get('categoria')"
        v-if="form.errors.has('categoria')"
      ></b-form-feedback>

      <label>Tipo Vínculo</label>
      <b-form-group>
        <b-form-radio-group
          v-model="form.tp_vinculo"
          :options="this.$parent.optionsTpVinculo"
          name="tp_vinculo"
          stacked
          plain
        ></b-form-radio-group>
      </b-form-group>
      <b-form-feedback
        v-text="form.errors.get('tp_vinculo')"
        v-if="form.errors.has('tp_vinculo')"
      ></b-form-feedback>

      <label>Status</label>
      <b-form-group>
        <b-form-radio-group
          v-model="form.status"
          :options="this.$parent.optionsLivStatus"
          name="status"
          stacked
          plain
        ></b-form-radio-group>
      </b-form-group>
      <b-form-feedback
        v-text="form.errors.get('status')"
        v-if="form.errors.has('status')"
      ></b-form-feedback>

      <label>Obs.</label>
      <b-form-textarea
        v-model="form.obs"
        name="obs"
        placeholder="Observação"
        :rows="3"
        :max-rows="6"
      >
      </b-form-textarea>
      <b-form-feedback
        v-text="form.errors.get('obs')"
        v-if="form.errors.has('obs')"
      ></b-form-feedback>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import moment from "moment";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      statusSelected: [],
      pessoaFisicaSelected: [],
      categoriaSelected: [],
      errors_array: [],
      form: new Form({
        tp_vinculo: "",
        cnh: "",
        pesmot_id: "",
        pessoa_id: "",
        dt_vencimento_cnh: "",
        categoria: "",
        obs: "",
        status: "",
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    pessoaFisicaSelected(obj) {
      this.form.pessoa_id = obj.value;
    },
    categoriaSelected(obj) {
      this.form.categoria = obj.value;
    },
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.pesmot_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.errors_array = "";
      this.errors_array = [];
      this.pessoaFisicaSelected = [];
      this.categoriaSelected = [];
      this.form.reset();
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.pessoaFisicaSelected = [];
      this.categoriaSelected = [];
      this.form.cnh = data.cnh;
      this.form.dt_vencimento_cnh = data.dt_vencimento_cnh;
      this.form.status = data.status.valor;
      this.form.tp_vinculo = data.tp_vinculo.valor;
      this.form.pesmot_id = data.pesmot_id;
      this.form.obs = data.obs;
      this.categoriaSelected = {
        label: data.categoria.descr,
        value: data.categoria.valor,
      };
      this.pessoaFisicaSelected = {
        label: data.pessoa_fisica.nome + " - " + data.pessoa_fisica.cpf,
        value: data.pessoa_fisica.pessoa_id,
      };
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.dt_vencimento_cnh = this.formatDateSubmit(
        this.form.dt_vencimento_cnh
      );
      this.form
        .put("/api/" + this.rota + "/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.dt_vencimento_cnh = this.formatDateSubmit(
        this.form.dt_vencimento_cnh
      );
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then((response) => {
          new ReturnApi(response, this);

          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    formatDate(value, fmt = "DD MM YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
